var map = {
	"./1.png": 480,
	"./10.png": 858,
	"./2.png": 515,
	"./3.png": 162,
	"./4.png": 725,
	"./5.png": 572,
	"./6.png": 135,
	"./7.png": 46,
	"./8.png": 529,
	"./9.png": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 414;